const team = {
  id: null,
  teamName: null,
  managerId: null,
  managerName: null,
  teamMembers: []
}

export default () => Object.assign({}, team)
